
export default function Features() {
  const features = [
    {
      icon: 'ri-lock-password-line',
      title: 'Complete Privacy Protection',
      description: 'Hide your IP address and encrypt all your internet traffic to ensure complete anonymity online. No one can track your browsing activities or steal your personal information.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-earth-line',
      title: 'Access Global Content',
      description: 'Bypass geo-restrictions and access your favorite content from anywhere in the world. Stream, browse, and download without limitations or censorship.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-wifi-line',
      title: 'Secure Public WiFi',
      description: 'Stay protected on public WiFi networks at cafes, airports, and hotels. Our VPN creates a secure tunnel that prevents hackers from intercepting your data.',
      color: 'from-pink-500 to-pink-600'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely private and are never stored on our servers.',
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, Mac, iOS, Android, and more. Secure up to 5 devices simultaneously.',
      color: 'from-cyan-500 to-cyan-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always ready to help you. Get instant assistance through email or phone whenever you need it.',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Powerful Features for Your Security</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Everything you need to stay safe and anonymous online</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group">
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
